import 'react-app-polyfill/ie11';
import './utils/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App/index';

import 'semantic-ui-css/semantic.min.css';
import '../node_modules/react-datepicker/dist/react-datepicker.css'
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
